module.exports = __webpack_public_path__ + "static/media/portal_user_mgmt_active.e080315b.svg";